import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ProductImageMissingVisualConfig } from '@epicuro-next/ataraxia/product-image';
import { verticalCollapse } from '@epicuro-next/ui';
import { Prepack, ScaleSets } from 'graphql-api/gql-api-interfaces';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export const COLLAPSED = 'collapsed';
export const EXPANDED = 'expanded';
type CollapseState = typeof COLLAPSED | typeof EXPANDED;

@Component({
  selector: 'epc-pre-pack-details',
  templateUrl: './pre-pack-details.component.html',
  styleUrls: ['./pre-pack-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [verticalCollapse('*', '0', 250)],
  standalone: false,
})
export class PrePackDetailsComponent implements OnInit, OnDestroy {
  // tslint:disable:no-any
  @Input() public deliveryItems: any;
  @Input() public prepack: Prepack;
  @Input() public scaleSets: ScaleSets;
  @Input() public selectedScale: string;
  @Input() public showAddNote: boolean;
  @Input() public set collapseState(value: CollapseState) {
    this.collapsestate = value;
    if (value === EXPANDED && !this.showSizeGrid) {
      this.showSizeGrid = true;
    }
  }
  @Input() public discountVisible: boolean;
  @Input() public portableGrid: boolean;
  @Input()
  public set note(value: string | null | undefined) {
    if (value === undefined || value === this.noteControl.value) {
      return;
    }

    this.noteControl.patchValue(value);
  }
  @Input() public discount: { min: number; max: number };
  @Input() public titleAttributes: string[];
  @Input() public differentMaterialDimensions = false;
  @Input()
  public productImageMissingVisualConfig?: ProductImageMissingVisualConfig;
  @Output() public noteChanged = new EventEmitter();
  @Output() public clickedMaterialImage = new EventEmitter<string>();

  public collapsestate: CollapseState;

  public noteControl = new UntypedFormControl();

  private destroyed$ = new Subject<void>();

  public showSizeGrid = false;

  public ngOnInit(): void {
    this.noteControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((note) => {
        this.noteChanged.emit(note);
      });
  }

  public ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public clickMaterialImage(variantId: string) {
    this.clickedMaterialImage.emit(variantId);
  }
}
